import { afterNextRender, ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../../auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MetaService } from '../../../meta.service';
import { backend } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'verify-change',
  templateUrl: './verify-change.component.html',
  styleUrls: ['./verify-change.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatButtonModule]
})
export default class VerifyChangeComponent {
  activated = inject(ActivatedRoute);
  meta = inject(MetaService);
  destroy = inject(DestroyRef);
  http = inject(HttpClient);
  toast = inject(ToastrService);

  verified = signal<{ state: boolean|null; message: string; }>({ state: null, message: 'Verifying your request...' });

  failed: boolean = false;

  constructor() { 
    const code: string = this.activated.snapshot.queryParams?.c;

    afterNextRender(() => {
      if(code){
        this.http.post<{ message: string; }>(backend + 'change-request/verify', { verification: code }).pipe(takeUntilDestroyed(this.destroy)).subscribe({
          next: response => {
            this.meta.title.setTitle(`cloudigo | ${response.message}`);
            this.verified.set({ state: true, message: response.message });
  
          },
          error: error => {
            this.verified.set({ state: false, message: 'We were unable to verify your email address' })
            this.toast.error((error.error || error).message || 'We were unable to verify your email address');
          }
        });
      } else {
        this.verified.set({ state: false, message: 'No verification code was provided' })
      }
    });
  }
}
